module.exports = __webpack_public_path__ + "img/cuff buttons quantity.f9083af5.png";